import { palette } from '@livable/saas-react-components';
import breakpointsFunc from '../breakpointsFunc';
const MuiTableCell = {
  styleOverrides: {
    root: {
      borderBottom: "1px solid ".concat(palette.shades[300]),
      fontSize: '16px',
      lineHeight: '24px',
      padding: '18px 5px',
      [breakpointsFunc.breakpoints.up('sm')]: {
        minHeight: '72px'
      },
      '&:first-of-type': {
        paddingLeft: '24px'
      },
      '&:last-of-type': {
        paddingRight: '24px'
      }
    },
    head: {
      fontWeight: '600',
      fontSize: '13px',
      lineHeight: '16.5px',
      padding: '18px 5px'
    }
  }
};
export default MuiTableCell;